import Vimeo from '@vimeo/player';
import { gsap } from "gsap";

export default class VideoModal {
	constructor(elm) {
        const self = this;
        this.modal = elm;

        this.closeButton = this.modal.querySelector('[data-video-modal-close]');
        this.closeButton.addEventListener('click', function() {
            self.close();
        });

        this.modalContent = this.modal.querySelector('[data-video-modal-content]');
	}

    open(vimeoID) {
        const self = this;
        if(!vimeoID) {
            return;
        }

        this.modal.classList.add('c-video-modal--open');

        window.dispatchEvent(new CustomEvent('disable-scroll'));

        gsap.set(this.modal, {
			display: 'flex',
		});

        const tl = gsap.timeline({
            onComplete: () => {
                this.vimeo = new Vimeo(this.modalContent, {
                    id: vimeoID,
                    dnt: true,
                    autopause: false,

                    background: false,
                    loop: false,
                    autoplay: false,
                    controls: true,

                    quality: 'auto',
                    responsive: true,
                    transparent: true,

                    muted: false,
                    keyboard: true,
                    playsinline: false,

                    // Visuals
                    byline: false,
                    portrait: false,
                    speed: false,
                    title: false,
                });

                this.vimeo.ready().then(function() {
                    self.vimeo.play();
                });
            }
        });
        tl.to(this.modal, {
			yPercent: 100,
			duration: 0.8,
			ease: 'power1.out',
		});

        window.addEventListener('keydown', e => {
			if (e.key === 'Escape') {
				this.close();
			}
        });

    }

    close() {
        this.modal.classList.remove('c-video-modal--open');

        window.dispatchEvent(new CustomEvent('enable-scroll'));

        if(this.vimeo) {
            this.vimeo.pause();

            const tl = gsap.timeline({
                onComplete: () => {
                    gsap.set(this.modal, {
                        display: 'none',
                    });
                    this.vimeo.destroy();
                    this.modalContent.innerHTML = '';
                }
            });
            tl.to(this.modal, {
				yPercent: 0,
				duration: 0.8,
				ease: 'power1.inOut',
			});

        }
    }

}
